import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

import ValueLabel from '@material-ui/core/Slider/ValueLabel';

const StyledValueLabel = withStyles((props) => ({
  offset: {
    top: 18,
    left: props => props.index === 0 ? "calc(-25% + -20px)" : "calc(-50% + 12px)"
  },
  circle: {
    transform: props => props.index === 0 ? "rotate(-135deg)" : "rotate(0deg)"
  },
}))(ValueLabel);

const CustomVerticalSlider = withStyles({
  root: {
    color: '#8d8d8d',
    height: 8,
    '&$vertical': {
      width: 8
    }
  },
  thumb: {
    height: 40,
    width: 40,
    zIndex: 1,
    background: 'red',
    background: 'linear-gradient(to right, rgb(242, 65, 60) 50%, rgba(242, 65, 60, 0) 50%) left',
    backgroundSize: '200%',
    marginBottom: "-20px !important",
    boxShadow: "none !important",
    transition: 'background .1s ease-out',
    '&.MuiSlider-active': {
      backgroundPosition: 'right',
    },
    marginLeft: "-15px !important",
  },
  active: {},
  track: {
    width: "10px !important",
    color: "#F2413C",
    zIndex: 1
  },
  rail: {
    opacity: 1,
    width: "10px !important",
    zIndex: 1
  },
  valueLabel: {
    fontFamily: "inherit",
    borderColor: '#F2413C !important',
    color: '#F2413C !important',
    fontWeight: 'bold',
    width: 42,
    height: 42,
    top: 13,
    transformOrigin: "top right !important",
  },
  mark: {
    backgroundColor: 'rgba(55,55,55,0.5)',
    height: 2,
    width: 50,
    marginTop: -1,
    marginLeft: "-20px !important",
    zIndex: 0,
  },
  markLabel: {
    fontFamily: "inherit",
    opacity: 1,
    color: "#000000",
    marginLeft: "32px !important",
    marginBottom: "2px !important",
  },
})(Slider);

const CustomHorizontalSlider = withStyles({

})(Slider);

export default function CustomSlider(props) {
  return (
    <div className={'h-slider-xxs xs:h-slider-xs'}>
      <CustomVerticalSlider
        defaultValue={props.defaultValue}
        value={props.value ?? ""}
        min={props.min}
        max={props.max}
        marks={props.marks}
        onChange={props.onChange}
        orientation={props.orientation ?? "vertical"}
        valueLabelDisplay="auto"
        aria-label={props.ariaLabel}
        ValueLabelComponent={StyledValueLabel}
      />
    </div>
  );
}